import { connect } from 'react-redux'
import { isAuthenticatedSelector } from 'selectors/globalSelectors'
import { State } from 'interfaces/state'
import { OverlayStateProps, OverlayDispatchProps, OverlayOwnProps, Overlay } from 'components/features/pfm/Overlay/Overlay'
import { withRouter, RouteComponentProps } from 'react-router-dom'

const mapStateToProps = (state: State): OverlayStateProps => ({
  isAuthenticated: Boolean(isAuthenticatedSelector(state)),
})

type OverlayContainerInnerOwnProps =
  & OverlayOwnProps
  & RouteComponentProps<{}>

const OverlayContainerInner = connect<
  OverlayStateProps, OverlayDispatchProps, OverlayContainerInnerOwnProps
>(mapStateToProps)(Overlay)

export const OverlayContainer = withRouter(OverlayContainerInner)
